import { render, staticRenderFns } from "./NewMarqueeComponent.vue?vue&type=template&id=6dcb332e&"
import script from "./NewMarqueeComponent.vue?vue&type=script&lang=js&"
export * from "./NewMarqueeComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewMarqueeComponent.vue?vue&type=style&index=0&id=6dcb332e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports